import type { ReactNode } from 'react';

export interface TabItem {
  readonly id: string;
  readonly label: string;
  /** Optional trailing count/badge. */
  readonly badge?: ReactNode;
  /** Optional leading icon. */
  readonly icon?: ReactNode;
}

interface TabsProps {
  readonly items: readonly TabItem[];
  readonly activeId: string;
  readonly onSelect: (id: string) => void;
  readonly ariaLabel?: string;
}

/** Segmented tab row (e.g. list buckets or record sections). Same behaviour in every module. */
export function Tabs({ items, activeId, onSelect, ariaLabel }: TabsProps) {
  return (
    <div className="forq-tabs" role="tablist" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={item.id === activeId}
          className={`forq-tabs__tab${item.id === activeId ? ' is-active' : ''}`}
          onClick={() => onSelect(item.id)}
        >
          {item.icon ? <span className="forq-tabs__icon" aria-hidden="true">{item.icon}</span> : null}
          {item.label}
          {item.badge !== undefined && item.badge !== null ? (
            <span className="forq-tabs__badge">{item.badge}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
